"use client";

import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import {
  type TrendingOnEdxProductTabsData,
  type TrendingOnEdxProductTabsResult,
} from "@/components/ProductCardListWrapper/variants/ProductCardListBySearchTab/types";
import { getHomepageTrendingMonarchParams } from "./getHomepageTrendingMonarchParams";

export const NEUTRAL_DATA: TrendingOnEdxProductTabsData = {
  enabled: false,
  prioritizeCoursesFirst: false,
  categoryKeyOrder: [],
  showTrendingFlameIcon: false,
  categories: {
    replaceContent: false,
    appendToEnd: false,
    items: [],
    category: {
      productType: "",
      categoryKey: "",
      name: "",
      additionalProductTypes: [],
    },
  },
  expandableFooter: {
    maxExpandedRows: 2,
    ctaLabel: "Explore more learning options",
  },
};

type HomepageTrendingCourseUpdateMonarchValue = {
  data?: TrendingOnEdxProductTabsData;
};

const RULE_ID = "homepageTrendingCourseUpdate";

export type UseHomepageTrendingCourseUpdateOptions = {
  /** When false, skips Monarch fetch (e.g. feature flag off). */
  enabled?: boolean;
};

export default function useHomepageTrendingCourseUpdate(
  options?: UseHomepageTrendingCourseUpdateOptions,
): TrendingOnEdxProductTabsResult {
  const { isLoading, value } =
    useMonarchRule<HomepageTrendingCourseUpdateMonarchValue>(
      RULE_ID,
      getHomepageTrendingMonarchParams(),
      { enabled: options?.enabled !== false },
    );

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "legacy",
      data: NEUTRAL_DATA,
    };
  }

  const { data } = value;
  return {
    isLoading,
    variant: "test",
    data: {
      enabled: value.data?.enabled ?? false,
      prioritizeCoursesFirst:
        data?.prioritizeCoursesFirst ?? NEUTRAL_DATA.prioritizeCoursesFirst,
      categoryKeyOrder: data?.categoryKeyOrder ?? NEUTRAL_DATA.categoryKeyOrder,
      showTrendingFlameIcon:
        data?.showTrendingFlameIcon ?? NEUTRAL_DATA.showTrendingFlameIcon,
      categories: data?.categories ?? NEUTRAL_DATA.categories,
      expandableFooter: data?.expandableFooter ?? NEUTRAL_DATA.expandableFooter,
    },
  };
}
